<template>
	<v-toolbar color="rgba(0, 0, 0, 0)" height="150">
		<v-container>
			<v-row align="center">
				<v-col cols="6">
					<v-row align="center">
						<v-col>
							<v-toolbar-title>
								<a href="/">
									<v-img max-width="300" :src="logo"/>
								</a>
							</v-toolbar-title>
							<v-toolbar-items class="pa-2">
								<span v-if="isManager" class="admin">מנהל מערכת</span>
								<span v-if="!isManager" class="admin">{{user.company && user.company.name}}</span>
							</v-toolbar-items>
						</v-col>
					</v-row>
				</v-col>

				<v-col cols="6">
					<v-row justify="end" v-if="isConnected">
						<div class="navigation">
							<div class="block" v-for="(route, index) in routes" :key="route.name">
								<span class="link" v-if="index">|</span>

								<v-btn text :to="route" class="red--text">
									<span class="link">{{route.title}}</span>
								</v-btn>

							</div>
							<span>|</span>
							<v-btn text @click="doLogout" class="red--text">
								<span class="link">התנתק</span>
							</v-btn>
						</div>
					</v-row>
				</v-col>
			</v-row>

		</v-container>
	</v-toolbar>
</template>

<script>
	import {types as AuthTypes} from "src/store/modules/Auth.module";

	export default {
		name: "top-toolbar",
		props: {
			value: {},
			routes: {
				type: Array,
				default: () => []
			},
			user: {},
			isManager: {type: Boolean},
			isConnected: {type: Boolean}
		},
		components: {},
		data() {
			return {
				open: true
			};
		},
		computed: {
			organization() {
				return this.$store.state.CurrentOrg.organization;
			},
			logo() {
				return this.organization.logo || "img/logo.jpg";
			},
			config() {
				return this.$store.state.ConfigModule;
			},
			companyLogo() {
				return this.config.app.logo;
			},
		},
		created() {
		},
		methods: {
			doLogout() {
				this.$store.dispatch(AuthTypes.LOGOUT).then(() => {
					location.reload();
				});
			}
		},
		watch: {
			value: {
				immediate: true,
				handler() {
					this.open = this.value;
				}
			},
			open: {
				immediate: true,
				handler(newValue) {
					if (this.value !== newValue) {
						this.$emit("close");
					}
				}
			}

		}

	};
</script>

<style scoped>
	.admin {
		color: #2f5dab;
		font-size: 22px;
		font-weight: bold;
	}

	.navigation .v-btn--active:before {
		opacity: 0;
	}

	.link {
		color: #0694d4;
	}

	.navigation .v-btn--active {
		border-bottom: 2px solid;
		border-radius: 0;
		color: #2f5dab;
		border-color: #2f5dab;
	}

	.navigation .v-btn--active .link {
		color: #2f5dab;
		border-color: #2f5dab;
	}

	.block {
		display: inline-block
	}

	.v-toolbar {
		box-shadow: unset
	}

</style>
